import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const run = async () => {
      const target = localStorage.getItem("urban_post_login") || "/";
      localStorage.removeItem("urban_post_login");
      if (!match) { navigate("/"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: match[1] });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(target, { state: { user: data } });
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <Loader2 size={32} className="animate-spin text-neutral-400" aria-hidden="true" />
    </div>
  );
}
